import { render, staticRenderFns } from "./COAAllocationInfoModal3.vue?vue&type=template&id=cdcb631c&scoped=true&"
import script from "./COAAllocationInfoModal3.vue?vue&type=script&lang=js&"
export * from "./COAAllocationInfoModal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcb631c",
  null
  
)

export default component.exports